import { InjectionToken } from '@angular/core';

// TODO: realise, refactor and delete. Used to prevent looping flow in prescription multi-step modal
// Marks the component subtree rendered inside the multi-stepper modal. Prescription items read it to
// suppress actions that would re-open the modal, preventing an entry-point recursion loop.
export const MULTI_STEPPER_SCOPE = new InjectionToken<boolean>('MULTI_STEPPER_SCOPE');
